import React, { useState } from "react";
import A_SimpleDialog from "../../../../Atoms/Feedback/Dialogs/A_SimpleDialog";
import A_Button from "../../../../Atoms/Inputs/Buttons/A_Button";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import AddIcon from "@material-ui/icons/Add";
import useStyles from "./M_AddTaskDialog.styles";
import M_AddTaskForm from "../M_AddTaskForm/M_AddTaskForm";

const M_AddTaskDialog = ({ toolbar, onTaskCreated }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const addTaskConfig = toolbar?.primary?.addTaskButton || {};

  const handleClose = () => setOpen(false);

  const handleTaskCreated = (response) => {
    if (onTaskCreated) onTaskCreated(response);
  };

  return (
    <>
      <Grid item>
        <A_Button
          edge="start"
          premiumVariant="primary"
          className={classes.addTaskBtn}
          aria-label="add task"
          label={addTaskConfig.label || "Add Task"}
          startIcon={<AddIcon />}
          onClick={() => setOpen(true)}
        />
      </Grid>

      {open && (
        <A_SimpleDialog
          open={open}
          title={addTaskConfig.label || "Add Task"}
          fullScreen={false}
          height="auto"
          fullwidth={true}
          maxWidth="md"
          onClose={handleClose}
          closePopUp={handleClose}
          dialogContent={
            <M_AddTaskForm
              onClose={handleClose}
              onTaskCreated={handleTaskCreated}
            />
          }
          dialogActions={
            <div
              id="dialog-actions-container"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
                gap: "8px",
                padding: "8px 16px",
              }}
            />
          }
        />
      )}
    </>
  );
};

M_AddTaskDialog.propTypes = {
  toolbar: PropTypes.object.isRequired,
  onTaskCreated: PropTypes.func,
};

export default M_AddTaskDialog;
